<template>
  <v-navigation-drawer
    v-model="isShowForm"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <div class="d-flex flex-column" style="height: calc(100% - 100px)">
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="onClickBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title> สถานะการส่งคำสั่ง </v-list-item-title>
            <v-list-item-subtitle>
              {{ commandData.title }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar>
      <div class="px-5 pb-5" style="height: 100%; overflow: auto">
        <div v-if="commandData.status === 'success'">
          <v-alert
            class="mt-2"
            outlined
            type="success"
            icon="mdi-check-circle-outline"
            text
            dense
          >
            <div>สำเร็จ</div>
            <div style="font-size: 11px; color: #333">
              {{ dateTimeFromNow(commandData.date) }}
            </div>
          </v-alert>
        </div>
        <div v-if="commandData.status === 'fail'">
          <v-alert
            class="mt-2"
            outlined
            type="error"
            icon="mdi-close-circle-outline"
            text
            dense
          >
            <div>ไม่สำเร็จ</div>
            <div style="font-size: 11px; color: #333">
              {{ dateTimeFromNow(commandData.date) }}
            </div>
          </v-alert>
        </div>
        <div v-if="commandData.status === 'success'">
          <v-list-item
            two-line
            v-for="(value, key) in commandData.responseData"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>
        <div v-if="commandData.status === 'fail'">
          <v-list-item
            two-line
            v-for="(value, key) in commandData.responseData"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ key.toUpperCase() }}
              </v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    isShowForm: {
      type: Boolean,
      required: true,
    },
    commandData: {
      type: Object,
      required: true,
    },
  },

  methods: {
    onClickBack() {
      this.$emit('onClickBack')
    },

    dateTimeFromNow(value) {
      return moment.utc(value, 'YYYY-MM-DD HH:mm:ss').locale('th').fromNow()
    },
  },
}
</script>
